import { dayjs } from '@lba-dev/package.local-globals/dayjs';

export const addressToString = (address) => {
  const roadNumber = address.number;
  const road = address.road;
  const zipcode = address.zipcode;
  const city = address.city;
  return `${roadNumber} ${road}, ${zipcode} ${city}`;
};
export const complementAdress = (client) => {
  const compl = client.compl ? `Complément d'adresse :\n${client.compl}` : '';
  const floor = client.floor ? `Etage : ${client.floor}, ` : '';
  const code = client.code ? `code : ${client.code}, ` : '';
  const building = client.building ? `bâtiment : ${client.building}` : '';
  const compl2 = floor || code || building ?
    `(${floor + code + building})\n` : '';
  return `${compl}\n${compl2}`;
};
export const clientToString = (client) => {
  const civility = client.civility || '';
  const name = client.name || '';
  const firstname = client.firstname ? ` ${client.firstname}` : '';
  if (client.civility === 'Société') {
    return `${civility}. ${client.society || ''}\n(${name}${firstname})`;
  }
  return `${civility}. ${name}${firstname}`;
};

export const dateToString = (date, flexHour, maxHour, definHClient) => {
  let string = `le ${dayjs(date).format('dddd DD MMMM YYYY [à] HH[h]mm')}`;
  if (flexHour) {
    string = `le ${dayjs(date).format('dddd DD MMMM YYYY [entre] HH[h]mm')
    } et ${dayjs(maxHour).format('HH[h]mm')}`;
  } else if (definHClient) {
    string = `le ${dayjs(date)
      .format('dddd DD MMMM YYYY[ (l\'heure à définir avec le client)]')}`;
  }
  return string;
};
